var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordWizardSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rewards/word-wizard-silver") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "3.515625e-05 0 45 0 45 47.9999652 3.515625e-05 47.9999652"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "3.515625e-05 0 45 0 45 44.5217043 3.515625e-05 44.5217043"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "3.515625e-05 0 45 0 45 44.5217043 3.515625e-05 44.5217043"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Rewards-1440",
    transform: "translate(-743.000000, -489.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rewards/word-wizard-silver",
    transform: "translate(743.000000, 489.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5000352,47.9999652 L22.5000352,47.9999652 C10.073707,47.9999652 3.515625e-05,38.0333565 3.515625e-05,25.7390957 L3.515625e-05,4.17387826 C3.515625e-05,1.86883478 1.88898047,-3.47826087e-05 4.21878516,-3.47826087e-05 L40.7812852,-3.47826087e-05 C43.1110898,-3.47826087e-05 45.0000352,1.86883478 45.0000352,4.17387826 L45.0000352,25.7390957 C45.0000352,38.0333565 34.9263633,47.9999652 22.5000352,47.9999652",
    id: "Fill-1",
    fill: "#8E9FA8",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5000352,44.5217043 L22.5000352,44.5217043 C10.073707,44.5217043 3.515625e-05,34.5550957 3.515625e-05,22.2608348 L3.515625e-05,4.17387826 C3.515625e-05,1.86883478 1.88898047,-3.47826087e-05 4.21878516,-3.47826087e-05 L40.7812852,-3.47826087e-05 C43.1110898,-3.47826087e-05 45.0000352,1.86883478 45.0000352,4.17387826 L45.0000352,22.2608348 C45.0000352,34.5550957 34.9263633,44.5217043 22.5000352,44.5217043",
    id: "Fill-4",
    fill: "#D6E4EF",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7812852,-3.47826087e-05 L4.21878516,-3.47826087e-05 C1.88898047,-3.47826087e-05 3.515625e-05,1.86883478 3.515625e-05,4.17387826 L3.515625e-05,22.2608348 C3.515625e-05,34.5550957 10.073707,44.5217043 22.5000352,44.5217043 C34.9263633,44.5217043 45.0000352,34.5550957 45.0000352,22.2608348 L45.0000352,4.17387826 C45.0000352,1.86883478 43.1110898,-3.47826087e-05 40.7812852,-3.47826087e-05 M40.7812852,4.17387826 L40.7812852,22.2608348 C40.7812852,32.2340522 32.5803867,40.3477913 22.5000352,40.3477913 C12.4196836,40.3477913 4.21878516,32.2340522 4.21878516,22.2608348 L4.21878516,4.17387826 L40.7812852,4.17387826",
    id: "Fill-7",
    fill: "#B6C4CE",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.6326992,10.4628522 C32.4361758,10.2072 32.1144961,10.0757217 31.7900039,10.0757217 L25.1743008,10.0757217 L25.1409023,10.0757217 C21.9121523,10.0757217 19.0071914,12.0169391 17.8009805,14.9800696 L12.9427383,26.9181565 L31.9696523,26.9181565 L27.3001992,15.3445913 C27.082582,14.805113 27.3332461,14.1915478 27.8686758,13.9529391 L32.2466836,12.0037217 C32.8320352,11.7432 33.047543,11.0030261 32.6326992,10.4628522",
    id: "Fill-10",
    fill: "#8E9FA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3707539,29.5763826 L10.6293867,29.5763826 C9.78141797,29.5763826 9.09411328,28.8963826 9.09411328,28.0574261 C9.09411328,27.2181217 9.78141797,26.5381217 10.6293867,26.5381217 L34.3707539,26.5381217 C35.2187227,26.5381217 35.9060273,27.2181217 35.9060273,28.0574261 C35.9060273,28.8963826 35.2187227,29.5763826 34.3707539,29.5763826",
    id: "Fill-12",
    fill: "#74858C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2108984,20.4015304 C25.3072266,20.3093565 25.2544922,20.1479652 25.1219531,20.1288348 L23.5248047,19.9010087 C23.4720703,19.8933565 23.4267187,19.8610087 23.4031641,19.8140522 L22.6880859,18.3904 C22.6585547,18.3312696 22.60125,18.3017043 22.5435937,18.3017043 C22.4862891,18.3017043 22.4289844,18.3312696 22.3991016,18.3904 L21.6840234,19.8140522 C21.6604687,19.8610087 21.6151172,19.8933565 21.5627344,19.9010087 L19.9655859,20.1288348 C19.8330469,20.1479652 19.7803125,20.3093565 19.8766406,20.4015304 L21.0308203,21.5069217 C21.0691406,21.5437913 21.0867187,21.5966609 21.0775781,21.6488348 L20.8047656,23.2105739 C20.7819141,23.3410087 20.9200781,23.440487 21.0382031,23.3792696 L22.4690625,22.640487 C22.4926172,22.628313 22.5179297,22.6224 22.5435937,22.6224 C22.5692578,22.6224 22.5949219,22.628313 22.618125,22.640487 L24.0489844,23.3792696 C24.1674609,23.440487 24.3052734,23.3410087 24.2824219,23.2105739 L24.0099609,21.6488348 C24.0008203,21.5966609 24.0183984,21.5437913 24.0567187,21.5069217 L25.2108984,20.4015304 Z",
    id: "Fill-14",
    fill: "#FFDC4A"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordWizardSilver);
export default __webpack_public_path__ + "static/media/word-wizard-silver.4c44033c5226038cee831eec1d5da7cd.svg";
export { ForwardRef as ReactComponent };